import i18next from 'i18next';
import get from 'lodash/get';
import { call, put, takeLatest } from 'redux-saga/effects';

import { pushNotification, NotificationType } from '@talend/notification-center';

import {
	deleteCustomAttributeDefinition,
	getCustomAttributeDefinitions as fetchCustomAttributeDefinitions,
} from '../../api/customAttributes';
import {
	closingCustomAttributeDelete,
	resetCADListDataAction,
	setCADListBeginLoadingAction,
	setCADListDataAction,
	setCADListStopLoadingAction,
} from './CADList.actions';
import {
	CLEAN_CUSTOM_ATTRIBUTE_DEFINITIONS,
	GET_CUSTOM_ATTRIBUTE_DEFINITIONS,
	REMOVING_CUSTOM_ATTRIBUTE_DEFINITION,
} from './CADList.constants';

export function* getCustomAttributeDefinitions(): Generator {
	yield put(setCADListBeginLoadingAction);
	const { data, response }: any = yield call(fetchCustomAttributeDefinitions);
	yield put(setCADListStopLoadingAction);
	if (response.ok) {
		yield put(setCADListDataAction(data.data));
	}
	return yield response;
}

export function* cleanCustomAttributeDefinitions(): Generator {
	yield put(resetCADListDataAction);
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function* removeCustomAttributeDefinition({ payload }: any): Generator {
	const { response }: any = yield call(deleteCustomAttributeDefinition, payload.id);
	if (response.ok) {
		yield put(
			pushNotification(
				null,
				i18next.t('tdc-app:REMOVED_CAD_MSG_NOTIFICATION_SUCCESS', {
					defaultValue:
						'The custom attribute definition {{customAttrLabel}} has been successfully deleted',
					customAttrLabel: payload.label,
				}),
				NotificationType.info,
			),
		);
		yield put(closingCustomAttributeDelete());
	} else {
		yield put(pushNotification(null, get(response, 'data.message'), NotificationType.error));
		yield put(closingCustomAttributeDelete());
	}
	yield call(getCustomAttributeDefinitions);
}

export default function* (): Generator {
	yield takeLatest(CLEAN_CUSTOM_ATTRIBUTE_DEFINITIONS, cleanCustomAttributeDefinitions);
	yield takeLatest(GET_CUSTOM_ATTRIBUTE_DEFINITIONS, getCustomAttributeDefinitions);
	yield takeLatest(REMOVING_CUSTOM_ATTRIBUTE_DEFINITION, removeCustomAttributeDefinition);
}
